'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	isOpen: false,
	isInTransition: false,
	positionV: 'bottom',
	tabIndex: 1,
	onBlur: function onBlur() {},
	onClick: function onClick() {},
	onFocus: function onFocus() {},
	onKeyDown: function onKeyDown() {},
	onKeyUp: function onKeyUp() {},
	onMouseDown: function onMouseDown() {},
	onMouseEnter: function onMouseEnter() {},
	onMouseLeave: function onMouseLeave() {},
	onMouseUp: function onMouseUp() {},
	onTouchEnd: function onTouchEnd() {},
	onTouchStart: function onTouchStart() {}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-speed-dial/dist/components/bubble-list-item/bubble-list-item.default-props.js
// module id = 4138
// module chunks = 0